import Constants from "src/helper/Constants";
import OrderAPICall from "../service/OrderAPICall";
import Helper from "src/helper/Helper";

class OrderRepository {

    fetchOrderList = async (param) => {
        let response = await new OrderAPICall().fetchOrderList(param)

        response?.orderList?.forEach(val => {
            let orderItem = []
            let trackingNumber = []
            let invoiceNumber = []
            let doNumber = []

            val?.orderItems?.forEach(item => {
                if (item?.backendItems.length > 0) {
                    item?.backendItems?.forEach(backendItem => {
                        let lineItemNo = backendItem?.backendItemNum
                        if (Number(backendItem?.backendItemNum) <= 0 || !backendItem?.backendItemNum) lineItemNo = item?.frontendItemNum
                        let data = { ...backendItem, ...item, backendItemNum: lineItemNo }
                        orderItem.push(data)
                        backendItem?.processedDetails?.forEach((detail, index) => {
                            let updatedDetail = { ...detail };

                            if (backendItem?.soItemStatus === Constants.orderStatus.Shipped) {
                                updatedDetail.atsDate = detail?.invoiceDate;
                            }
                            backendItem.processedDetails[index] = updatedDetail;

                            if (detail?.shippingTrackingNum && !trackingNumber.includes(detail.shippingTrackingNum)) {
                                trackingNumber.push(detail.shippingTrackingNum);
                            }

                            if (detail?.invoiceNum && !invoiceNumber.includes(detail.invoiceNum)) {
                                invoiceNumber.push(detail.invoiceNum);
                            }

                            if (detail?.doNum && !doNumber.includes(detail.doNum)) {
                                doNumber.push(detail.doNum);
                            }
                        });
                    });
                } else {
                    orderItem.push({ ...item, backendItems: [], processedDetails: [], backendItemNum: item?.frontendItemNum })
                }
            });
            val.orderItems = orderItem
            val.orderHeader.trackingNumber = trackingNumber
            val.orderHeader.invoiceNumber = invoiceNumber
            val.orderHeader.doNumber = doNumber
            val.orderHeader.orderTotal = val.orderHeader.orderTotal + val.orderHeader.taxAMT + (val.orderHeader?.freightCharges || 0) 
        });

        return response
    };

    sendEmailSalesRepresentativeOrder = async (lineItemNumber, purchaseOrderNumber, orderNumber) => {
        return await new OrderAPICall().sendEmailSalesRepresentativeOrder({ lineItemNumber, purchaseOrderNumber, orderNumber });
    };

    sendOrderItemEmail = async (params) => {
        return await new OrderAPICall().sendOrderItemEmail(params);
    };

    placeYourOrder = async (params) => {
        return await new OrderAPICall().placeYourOrder(params);
    };

    fetchPlaceOrderItems = async (params) => {
        let orderDetail = await new OrderAPICall().fetchPlaceOrderItems(params);
        return orderDetail;
    };

    orderDownloadInvoice = async (invoiceNumber) => {
        return await new OrderAPICall().orderDownloadInvoice(invoiceNumber);
    };

    exportOrder = async (params) => {
        return await new OrderAPICall().exportOrder(params);
    };
    exportEmail = async (params) => {
        return await new OrderAPICall().exportEmail(params);
    };

    exportEmailSales = async (params) => {
        return await new OrderAPICall().exportEmailSales(params);
    };

    fetchOrderExportCount = async (params) => {
        return await new OrderAPICall().getExportOrderCount(params);
    };

    fetchManufacturerList = async (params) => {
        return await new OrderAPICall().fetchManufacturerList(params);
    };

    sendOrderPOLineItemEmail = async (params) => {
        return await new OrderAPICall().sendOrderPOLineItemEmail(params);
    };

    getValidateOrderFromServer = async (params) => {
        return await new OrderAPICall().getValidateOrderFromServer(params);
    };

    fetchOrderDetail = async (params) => {
        let res = await new OrderAPICall().fetchOrderDetail(params);
        let response = res?.data[0]
        let orderItem = []
        let orderItemTab = []
        let updatedData = [...orderItem];
        let count = 1;
        let shipmentGroups = new Map();
        const { orderStatus: { Shipment, Shipped, OrderInProcess, NotYetShipped, PartiallyShipped, Cancelled, OrderReceived } } = Constants

        response?.orderItems?.forEach(item => {
            if (item?.backendItems.length > 0) {
                item?.backendItems?.forEach((backendItem, i) => {
                    let lineItemNo = backendItem?.lineItemNumber
                    if (Number(backendItem?.lineItemNumber) <= 0 || !backendItem?.lineItemNumber) lineItemNo = item?.frontendItemNum

                    let data = { ...backendItem, ...item, uniqueNumber: Helper.UUID(), lineItemNumber: lineItemNo, mainQuantity: item?.quantity }

                    const isPartiallyShippedMatch = (item?.backendItems?.some(
                        obj =>
                            obj?.lineStatus === PartiallyShipped &&
                            obj?.lineItemNumber === backendItem?.lineItemNumber
                    )) && backendItem?.lineStatus === OrderInProcess;

                    if (!isPartiallyShippedMatch) {
                        orderItemTab.push(data);
                    }

                    if (backendItem?.processedDetails?.length > 0) {
                        backendItem?.processedDetails?.forEach((detail, index) => {
                            orderItemTab[i].doNumber?.push(detail?.deliveryOrderNum)

                            let qty = (backendItem?.lineStatus === OrderReceived || backendItem?.lineStatus === Cancelled) ? item?.quantity
                                : (backendItem?.lineStatus === Shipped || backendItem?.lineStatus === PartiallyShipped) ? detail?.deliveryQuantity
                                    : backendItem?.lineStatus === OrderInProcess ? backendItem?.remainingQuantity
                                        : backendItem?.scheduledQuantity

                            let deliveryDate = backendItem?.lineStatus === Constants.orderStatus.Shipped ? detail?.invoiceDate : detail?.expectedDeliveryDate
                            backendItem.processedDetails[index].expectedDeliveryDate = deliveryDate;

                            let data = {
                                ...backendItem,
                                ...item,
                                ...detail,
                                lineItemNumber: lineItemNo,
                                totalPrice: detail?.deliveryQuantity ? (detail?.deliveryQuantity * item?.unitPrice)?.toFixed(2) : item?.totalPrice,
                                uniqueNumber: Helper.UUID(),
                                mainQuantity: qty,
                                expectedDeliveryDate: deliveryDate
                            };
                            orderItem.push(data);
                        });
                    } else {
                        let qty = (backendItem?.lineStatus === OrderReceived || backendItem?.lineStatus === Cancelled) ? item?.quantity
                            : backendItem?.lineStatus === OrderInProcess ? backendItem?.remainingQuantity
                                : backendItem?.scheduledQuantity
                        let data = {
                            ...backendItem,
                            ...item,
                            totalPrice: backendItem?.lineStatus === OrderInProcess ? (backendItem?.remainingQuantity * item?.unitPrice)?.toFixed(2) : item?.totalPrice,
                            uniqueNumber: Helper.UUID(),
                            lineItemNumber: lineItemNo,
                            mainQuantity: qty
                        };
                        orderItem.push(data);
                    }
                });
            } else {
                orderItemTab.push({
                    ...item,
                    backendItems: [],
                    processedDetails: [],
                    lineItemNumber: item?.frontendItemNum,
                    uniqueNumber: Helper.UUID(),
                    mainQuantity: item?.quantity
                })
            }
        });

        orderItemTab?.forEach((item, i) => {
            let quantityByItem = item?.scheduledQuantity ? item?.scheduledQuantity : item?.quantity
            if (item) {
                item.quantity = quantityByItem;
            }
        })

        response['orderItems'] = orderItemTab

        orderItem.forEach((item, i) => {
            if (item.lineStatus?.trim() === Shipped || item.lineStatus === PartiallyShipped) {
                const key = `${item.lineStatus}-${item.expectedDeliveryDate}`;

                if (!shipmentGroups.has(key)) {
                    shipmentGroups.set(key, Shipment + " " + count);
                    count++;
                }

                updatedData[i] = { ...item, shipment: shipmentGroups.get(key) };
            } else if (item.lineStatus === OrderInProcess || item.lineStatus === OrderReceived) {
                updatedData[i] = { ...item, shipment: NotYetShipped };
            } else if (item.lineStatus === Cancelled) {
                updatedData[i] = { ...item, shipment: Cancelled };
            }
        })

        let groupedData = [];

        updatedData.forEach(item => {
            let shipmentGroup = groupedData.find(group => group.shipment === item.shipment);

            if (!shipmentGroup) {
                shipmentGroup = {
                    shipment: item.shipment,
                    orderDate: response?.orderHeader?.orderCreationType === 'Online' ? response?.orderHeader?.frontendOrderCreatedOn : response?.orderHeader?.backendOrderCreatedOn,
                    shippedDate: item.shippedDate,
                    orderItems: [],
                    trackingNumber: [],
                    invoiceNumber: [],
                    doNumber: []
                };
                groupedData.push(shipmentGroup);
            }

            let { shipment, ...rest } = item;
            shipmentGroup.orderItems.push(rest);
            shipmentGroup?.orderItems?.forEach(detail => {
                if (detail?.shippingTrackingNum && !shipmentGroup?.trackingNumber?.includes(detail?.shippingTrackingNum)) {
                    shipmentGroup?.trackingNumber.push(detail?.shippingTrackingNum);
                }
                if (detail?.invoiceNumber && !shipmentGroup?.invoiceNumber?.includes(detail?.invoiceNumber)) {
                    shipmentGroup?.invoiceNumber.push(detail?.invoiceNumber);
                }
                if (detail?.deliveryOrderNum && !shipmentGroup?.doNumber?.includes(detail?.deliveryOrderNum)) {
                    shipmentGroup?.doNumber.push(detail?.deliveryOrderNum);
                }
            });

            const notYetShippedData = [PartiallyShipped, OrderInProcess];
            const itemLength = shipmentGroup.orderItems.length + (shipmentGroup.orderItems.length === 1 ? " Item" : " Items");

            shipmentGroup.orderStatus = item.lineStatus?.trim() === Shipped
                ? `${Shipped} - (${itemLength})`
                : item.lineStatus === Cancelled
                    ? `${Cancelled} - (${itemLength})`
                    : notYetShippedData.every(value => shipmentGroup.orderItems.some(obj => obj.lineStatus === value))
                        ? `${OrderInProcess} / ${PartiallyShipped} - (${itemLength})`
                        : item.lineStatus === PartiallyShipped
                            ? `${PartiallyShipped} - (${itemLength})`
                            : item.lineStatus === OrderInProcess
                                ? `${OrderInProcess} - (${itemLength})`
                                : item.lineStatus === OrderReceived
                                    ? `${OrderReceived} - (${itemLength})` : "";
        });

        const shipmentOrders = [];
        const cancelledOrders = [];
        const notYetShippedOrders = [];

        groupedData.forEach((item) => {
            if (item.shipment.startsWith(Shipment)) {
                shipmentOrders.push(item);
            } else if (item.shipment === Cancelled) {
                cancelledOrders.push(item);
            } else if (item.shipment === NotYetShipped) {
                notYetShippedOrders.push(item);
            }
        });

        shipmentOrders.sort((a, b) => {
            const aNumber = parseInt(a.shipment.split(" ")[1]);
            const bNumber = parseInt(b.shipment.split(" ")[1]);
            return aNumber - bNumber;
        });

        groupedData = [...shipmentOrders, ...notYetShippedOrders, ...cancelledOrders];

        response['orderItemByShipment'] = groupedData
        response['onlineSupportEmail'] = res?.onlineSupportEmail
        response['salseRespEmail'] = res?.salseRespEmail
        response['smrEmail'] = res?.smrEmail

        return response
    };

    orderCancellationEmail = async (params) => {
        return await new OrderAPICall().orderCancellationEmail(params);
    };

    orderEmailInvoice = async (params) => {
        return await new OrderAPICall().orderEmailInvoice(params);
    };

    fetchProductSpecificDetails = async (params) => {
        return await new OrderAPICall().fetchProductSpecificDetails(params);
    }
    
    fetchOrderServiceRepEmail = async () => {
        return await new OrderAPICall().fetchOrderServiceRepEmail();
    }
}

export default OrderRepository;